import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../theme/ISpcTheme';

const postcodeCheckStyles = makeStyles<ISpcTheme>(theme => ({
  modalWrapper: {
    padding: '2.5rem',
  },
  modalWrapperMobile: {
    padding: '3rem 1.5rem',
  },
  title: {
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily2,
    paddingBottom: '1.5rem',
    borderBottom: `0.01rem solid ${theme.palette.text.secondary}`,
  },
  mobileTitle: {
    paddingBottom: '1rem',
  },
  description: {
    fontFamily: theme.typography.fontFamily,
    padding: '1.5rem 0 2rem',
  },
  mobileDescription: {
    padding: '1rem 0',
  },
}));

export default postcodeCheckStyles;
